import React from 'react';
import UnlockCodesPanel from './UnlockCodesPanel';

/**
 * UnlockCodesTab — Billing Admin tab wrapper for global unlock-code management.
 */
export default function UnlockCodesTab() {
  return (
    <UnlockCodesPanel
      infoExtra={(
        <>
          {' '}To grant a tier to a specific org, use <strong>Grant to Org</strong> in the Subscription Overview tab.
        </>
      )}
    />
  );
}
